import { Box, Typography } from '@mui/material';

const ServiceName = () => (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
        <Typography variant='h5'>QUẢN LÝ KHO</Typography>
    </Box>
);

export default ServiceName;
